/* ==================================================
#Featured collection
#Featured promotions
#Slideshow
#Testimonials
#Gallery
#Video
#Cart
#Product
#Header
#Social media
#Map
#FAQ

/*============================================================================
  Featured collection
==============================================================================*/

var featuredCollectionSection = {
  init: function(){
    $('.js-product-slider .products-slider').each(function (index, value) {
      var products_per_slide = $(this).data('products-per-slide');
      var products_limit = $(this).data('products-limit');
      var products_available = $(this).data('products-available');
      var cellAlign,
          draggable,
          prevNext,
          wrapAround,
          initialIndex;
      
      if($(window).width() <= 798){
        products_per_slide = "3"; 
      }

      if (products_per_slide == "2" && products_available > products_per_slide && products_limit > products_per_slide || products_per_slide == "4" && products_available > products_per_slide && products_limit > products_per_slide || products_per_slide == "6" && products_available > products_per_slide && products_limit > products_per_slide){
        cellAlign = "left";
      } else {
        cellAlign = "center";
      }

      if (products_available > products_per_slide && products_limit > products_per_slide) {
        draggable = true;
        prevNext = true;
        wrapAround = true;
      } else {
        draggable = false;
        prevNext = false;
        wrapAround = false;
      }

      if (products_per_slide == "2" && products_available > products_per_slide || products_per_slide == "4" && products_available > products_per_slide || products_per_slide == "6" && products_available > products_per_slide){
        initialIndex = 0;
      } else if (products_per_slide == "3" && products_available) {
        initialIndex = 1;
      } else if (products_per_slide == "5" && products_available) {
        initialIndex = 2;
      } else if (products_per_slide == "7" && products_available) {
        initialIndex = 3;
      }

      if ($(window).width() <= 798) {
        cellAlign = "center";
        draggable = true;
        prevNext = true;
        wrapAround = true;
        initialIndex = 1;

        $(this).parents('.even-num-slides').removeClass('even-num-slides');
      }
      
      

      $(this).flickity({
        "lazyLoad": 2,
        "imagesLoaded": true,
        "draggable": draggable,
        "prevNextButtons": prevNext,
        "wrapAround": wrapAround,
        "cellAlign": cellAlign,
        "pageDots": usePageDots,
        "contain": true,
        "freeScroll": true,
        "arrowShape": arrowSize,
        "initialIndex": initialIndex,
        "autoPlay": true
      });

      $(this).addClass('slider-initialized');
    });
  },
  unload: function($target){
    var $slider = $target.find('.js-product-slider');
    if ($slider.hasClass('flickity-enabled')){
      $slider.flickity('destroy');
    }
  }
}

/*============================================================================
  Featured promotions
==============================================================================*/
var featuredPromotions = {
  init: function(){
    if ($(window).width() > 798 || $(window).width() == 0) {
      $('.feature-overlay').hover(function(){
        $(this).find('.feature-details').slideDown('100', function(){
          $(this).addClass('reveal-details');
        });
      }, function(){
        $(this).find('.feature-details').removeClass('reveal-details');
        $(this).find('.feature-details').slideUp('100');
      });

      $('.js-featured-promotions').each(function (index, value){
        var $promos = $(this);
        var animationStyle = $(this).data('promo-animation');

        $promos.waypoint(function() {
          $(this.element).find(".feature-section").addClass("animated " + animationStyle);
        }, { offset: '80%' });
      });
    }
  }
}

/*============================================================================
  Slideshow
==============================================================================*/

var slideshow = {
  init: function(){

    $('.js-homepage-slideshow').each(function (index, value){
      var $homepageSlider = $(this);
      var settings = {
        slideshowSpeed: $homepageSlider.data('slideshow-speed')*1000,
        slideshowTextAnimation: $homepageSlider.data('slideshow-text-animation'),
        adaptiveHeight: $homepageSlider.data('adaptive-height')
      }

      //initiate the slideshow
      if (!$homepageSlider.hasClass('flickity-enabled')){
        var arrowShow = $homepageSlider.find('.gallery-cell').length === 1 ? false : true;
        $homepageSlider.flickity({
                    adaptiveHeight: settings.adaptiveHeight,
                    wrapAround: true,
                    cellAlign: 'left',
                    imagesLoaded: true,
                    prevNextButtons: arrowShow,
                    draggable: arrowShow,
                    pageDots: usePageDots,
                    autoPlay: settings.slideshowSpeed,
                    arrowShape: arrowSize
                  });

        if (settings.slideshowTextAnimation != ''){
          var flkty = $homepageSlider.data('flickity');
          setTimeout(function() {
            $homepageSlider.find('.gallery-cell:nth-child(1) .caption-content').addClass('animated ' + settings.slideshowTextAnimation);
          }, 400);

          $homepageSlider.on( 'select.flickity', function() {
            if($homepageSlider.is(':visible')) {
              var currentSlide = flkty.selectedIndex + 1;
              setTimeout(function() {
                $homepageSlider.find('.caption-content').removeClass('animated ' + settings.slideshowTextAnimation);
                $homepageSlider.find('.gallery-cell:nth-child(' + currentSlide + ') .caption-content').addClass('animated ' + settings.slideshowTextAnimation);
              }, 400);
            }
          });
        }
      }

      if ($homepageSlider.find('.gallery-cell').length > 1) {
        $homepageSlider.addClass('multi-image');
      } else {
        $homepageSlider.addClass('single-image');
      }

      $homepageSlider.find('.gallery-cell').each(function(){
        var buttonWidth = 0;
        $(this).find('.action_button').each(function(){
          $button = $(this);
          if($(this).width() > buttonWidth){
              buttonWidth = $(this).width();
          }
        });
        $(this).find('.action_button').width(buttonWidth);
      });

    });
  },
  unload: function($target){

    var $slider = $target.find('.js-homepage-slideshow');
    $slider.flickity('destroy');

  }
}

/*============================================================================
  Testimonials
==============================================================================*/

var testimonial = {
  init: function(){

    $('.js-testimonial').each(function (index, value){
      var $testimonialSlider = $(this);
      var settings = {
        slideshowSpeed: $testimonialSlider.data('slideshow-speed')*1000,
        slideshowTextAnimation: $testimonialSlider.data('slideshow-text-animation')
      }

      if( $('.testimonial-image').length > 0){
        $('.testimonial-block').each(function(){
          if( $(this).find('.testimonial-image').length == 0){
            var theBlock = $(this).closest('.testimonial-block');
            $(theBlock).addClass('set-testimonial-height');
          }
        })
      }

      //initiate the slideshow
      if (!$testimonialSlider.hasClass('flickity-enabled')){
        var arrowShow = $testimonialSlider.find('.gallery-cell').length === 1 ? false : true;
        $testimonialSlider.flickity({
                        wrapAround: true,
                        cellAlign: 'left',
                        imagesLoaded: true,
                        prevNextButtons: arrowShow,
                        draggable: arrowShow,
                        pageDots: usePageDots,
                        autoPlay: settings.slideshowSpeed,
                        arrowShape: arrowSize
                      });

        if (settings.slideshowTextAnimation != ''){
          var flkty = $testimonialSlider.data('flickity');
          setTimeout(function() {
            $testimonialSlider.find('.gallery-cell:nth-child(1) .caption-content').addClass('animated ' + settings.slideshowTextAnimation);
          }, 400);

          $testimonialSlider.on( 'select.flickity', function() {
            if($testimonialSlider.is(':visible')) {
              var currentSlide = flkty.selectedIndex + 1;
              setTimeout(function() {
                $testimonialSlider.find('.caption-content').removeClass('animated ' + settings.slideshowTextAnimation);
                $testimonialSlider.find('.gallery-cell:nth-child(' + currentSlide + ') .caption-content').addClass('animated ' + settings.slideshowTextAnimation);
              }, 400);
            }
          });
        }
      }

      if ($testimonialSlider.find('.gallery-cell').length > 1) {
        $testimonialSlider.addClass('multi-image');
      } else {
        $testimonialSlider.addClass('single-image');
      }

      $testimonialSlider.find('.gallery-cell').each(function(){
        var buttonWidth = 0;
        $(this).find('.action_button').each(function(){
          $button = $(this);
          if($(this).width() > buttonWidth){
              buttonWidth = $(this).width();
          }
        });
        $(this).find('.action_button').width(buttonWidth);
      });

    });
  },

  unload: function($target){
    var $slider = $target.find('.js-testimonial');

    $slider.flickity('destroy');

  }
}

/*============================================================================
  Gallery
==============================================================================*/

var gallery = {
  init: function(){

    $('.gallery-horizontal').find('.gallery-image-wrapper').each(function(){
      var wrapper = $(this);
      var images = $(this).find("img");
      var imgWidth,
          imgHeight;

      $("<img />").attr("src", $(images).attr("src")).on('load', function() {
        imgWidth = this.width;
        imgHeight = this.height;

        $(wrapper).css("flex-basis", imgWidth * 200 / imgHeight);
        $(wrapper).css("flex-grow", imgWidth * 200 / imgHeight);
        $(wrapper).find("i").css("padding-bottom", imgHeight / imgWidth * 100 + '%');
    });
  });

  $('[rel=gallery]').fancybox({
    baseClass: "gallery-section__lightbox",
    clickContent: "nextOrClose"
  })

  }
}

/*============================================================================
  Video
==============================================================================*/

//check to see if HTML5 video is supported
var supports_video = function(){
  return !!document.createElement('video').canPlayType;
}

var videoSection = {
  init: function(){

    //Initialize lazy videos
    lazyframe('.lazyvideo--autoplay--true', {
      initinview: true,
    });

    lazyframe('.lazyvideo--autoplay--false', {
      initinview: false,
    });

    //Wrap product description iframes in responsive lazyframe div
    $('.product_section .description').find('iframe').wrap('<div class="lazyframe" data-ratio="16:9"></div>');

    function hideTextElements(parent) {
      parent.find('.caption').hide();
      parent.find('.action_button').hide();
    }

    var videoElement = $('.js-video.hide-text-on-video.video-autoplay--true').parents('.js-video-section');
    hideTextElements(videoElement);


    if($('.js-video').hasClass('hide-text-on-video') && $('.js-video').hasClass('video-autoplay--true')){
      var videoSection = $('.js-video').parents('.js-video-section');
      hideTextElements(videoSection);
    }

    $(".video-section .lazyvideo.hide-text-on-video").on('click', function(){
      var videoSection = $(this).parents('.js-video-section');
      hideTextElements(videoSection);
    })

    $('[data-play-video-button], video.hide-text-on-video, .lazyvideo--autoplay--false').on('click', function(){
      //Target parent lazyframe
      var videoSection = $(this).parents('.js-video-section');
      var lazyElement = videoSection.find('.lazyframe');
      var videoWrapper = videoSection.find('.js-video');
      if(videoWrapper.data('mp4') || videoWrapper.data('ogv')) {
        if(videoSection.find('.js-video.hide-text-on-video').length) {
          hideTextElements(videoSection);
        }
      } else{
        //create iframe and add settings
        var lazyIframe = document.createElement('iframe');
        iframeSrc = lazyElement.data('src');
        cleanIframeSrc = iframeSrc.substring(0, iframeSrc.indexOf('?')) + '?&autoplay=1';
        lazyIframe.src = cleanIframeSrc;
        lazyIframe.setAttribute('allowfullscreen', true);
        lazyIframe.setAttribute('frameborder', 0);
        //Append iframe to lazyframe
        lazyElement.append(lazyIframe);
        if(videoSection.find('.js-video.hide-text-on-video').length) {
          hideTextElements(videoSection);
        }
      }
    });
  },
  unload: function($target){
    $target.find('[data-play-video]').off('click');
    $target.find('video.hide-text-on-video').off('click');
  }
}

/*============================================================================
  Cart
==============================================================================*/
var cart = {
  init: function(){
    if ($('#cart_form .tos_agree').length) {
      //Terms of service on cart page
      $('body').on('click', "#cart_form input[type='submit']", function() {
        if ($(this).parents('form').find('.tos_agree').is(':checked')) {
          $(this).submit();
        } else {
          var warning = '<p class="warning animated bounceIn">' + "You must agree with the terms and conditions to checkout." + '</p>';
          if ($('p.warning').length == 0) {
            $(this).before(warning);
          }
          return false;
        }
      });
    }

    //Refresh page on add to cart if on cart page
    if($('body').hasClass('cart')) {
      $('.product_form form').on("submit", function(){
        setTimeout(function(){
          document.location.href = "/cart";
        }, 500);
      });
    }
  }
}

/*============================================================================
  Product
==============================================================================*/

selectCallback = function(variant, selector) {

  var $product = $('.product-' + selector.product.id);
  var $notify_form = $('.notify-form-' + selector.product.id);
  var $productForm = $('.product_form, .shopify-product-form', $product);
  var variantInventory = $productForm.data('variant-inventory');

  var $notifyFormInputs = $('.notify_form__inputs');

  var notifyEmail = "Enter your email address...";
  var notifyEmailValue = "";
  var notifySend = "Send";

  var notifyUrl = $notifyFormInputs.data('url');

  if (variant) {
    var notifyMessage = "Please notify me when "+variant.title+" becomes available - "+notifyUrl;
  }

  if ($notifyFormInputs.hasClass('customer--true')) {
    var notifyCustomerEmail = "";
    var notifyEmailInput = '<input type="hidden" class="notify_email" name="contact[email]" id="contact[email]" value="'+ notifyCustomerEmail +'" />'
  } else {
    var notifyEmailInput = '<input required type="email" class="notify_email" name="contact[email]" id="contact[email]" placeholder="'+ notifyEmail +'" value="'+ notifyEmailValue +'" />';
  }
  var notifyFormHTML = notifyEmailInput+'<input type="hidden" name="challenge" value="false" /><input type="hidden" name="contact[body]" class="notify_form_message" data-body="'+ notifyMessage +'" value="'+ notifyMessage +'" /><input class="action_button" type="submit" value="'+ notifySend + '" style="margin-bottom:0px" />';

  //Image Variant feature
  if (variant && variant.featured_image && $product.is(":visible")) {
    var $sliders = $('.js-product-gallery, .js-gallery-modal', $product);
    $sliders.each(function() {
      var $slider = $(this);
      var $sliderInstance = Flickity.data(this);
      if ($slider.is(":visible") && $sliderInstance != undefined ) {
        var index = $('[data-image-id="' + variant.featured_image.id + '"]').data('index');
        $sliderInstance.select( index, false, true );
      }
    });
  }

  if (variant) {
    if (variantInventory) {
      variantInventory.forEach(function(v){
        if (v.id === variant.id) {
          variant.inventory_quantity = v.inventory_quantity;
          variant.inventory_management = v.inventory_management;
          variant.inventory_policy = v.inventory_policy;
        }
      });
    }

    $('.sku span', $product).text(variant.sku);

    
      for (var i=0,length=variant.options.length; i<length; i++) {
        var radioButton = $productForm.find('.swatch[data-option-index="' + escape(i) + '"] :radio[value="' + variant.options[i].replace(/\"/g,'\\"') +'"]');
        if (radioButton.length) {
          radioButton.get(0).checked = true;
        }
      }
    
  }

  if (variant && variant.available == true) {
    if(variant.price < variant.compare_at_price){
      $('.was_price', $product).html('<span class="money">' + Shopify.formatMoney(variant.compare_at_price, $('body').data('money-format')) + '</span>');
      $('.savings', $product).html("You Save" + ' ' + parseInt(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price) + '% (' + '<span class="money">' + Shopify.formatMoney(variant.compare_at_price - variant.price, $('body').data('money-format')) + '</span>)');
      $('.current_price', $product).parent().addClass('sale');
    } else {
      $('.was_price', $product).html('');
      $('.savings', $product).html('');
      $('.current_price', $product).parent().removeClass('sale');
    }

    if (variant.inventory_management && variant.inventory_quantity > 0) {
      
        if (variant.inventory_quantity == 1) {
          items_left_text = "item left";
        } else {
          items_left_text = "items left";
        }

        var inventoryThreshold = 98;
        if (variant.inventory_quantity <= inventoryThreshold ) {
          $('.items_left', $product).html(variant.inventory_quantity + " " + items_left_text);
        } else {
          $('.items_left', $product).html("");
        }
      
      
        if(variant.inventory_policy == "deny") {
          $('.quantity', $product).attr('max', variant.inventory_quantity);
        }
      
    } else {
      $('.items_left', $product).text('');
      $('.quantity', $product).removeAttr('max');
    }

    $('.sold_out', $product).text('');

    if(wholesalePricing){
      var pricingLoaded = false;
      while(!pricingLoaded){
        if(wholesalePricing.pricingData !== {}){
          pricingLoaded = true;
          wholesalePricing.setProductPagePricing();
        }
      }      
    }else{
      if (variant.price > 0) {
        $('.current_price', $product).html('<span class="money">' + Shopify.formatMoney(variant.price, $('body').data('money-format')) + '</span>');
      } else {
        $('.current_price', $product).html("Free");
      }    
    }
    $('.add_to_cart', $product).removeClass('disabled').removeAttr('disabled').find('span').text($('.add_to_cart', $product).data('label'));
    $('.shopify-payment-button', $product).show();
    $notify_form.hide();
    $notifyFormInputs.empty();
  } else {
    var message = variant ? "Sold Out" : "Unavailable";
    $('.was_price', $product).text('');
    $('.savings', $product).text('');
    $('.current_price', $product).text('');
    $('.items_left', $product).text('');
    $('.quantity', $product).removeAttr('max');
    $('.sold_out', $product).text(message);
    $('.add_to_cart', $product).addClass('disabled').attr('disabled', 'disabled').find('span').text(message);
    $('.shopify-payment-button', $product).hide();
    $notify_form.hide();
    $notifyFormInputs.empty();
    if (variant && !variant.available) {
      $notify_form.fadeIn();
      $notifyFormInputs.empty();
      $notifyFormInputs.append(notifyFormHTML);
    }
  }
    
  $('.shopify-product-form select[name="id"]').change();

  
};

var productPage = {
  init: function(){

    var draggable = true;
    var prevNextButtons = true;
    var autoplay = $('.js-product-gallery').data('autoplay');

    setTimeout(function(){
     imageFunctions.linkGalleryAndCarousel($('.js-product-page-gallery .js-product-gallery'), $('.js-product-page-gallery .product_gallery_nav'));
    }, 1000);

    if($('.js-full-width-product-images').length){
      imageFunctions.fullWidth('.product-template .product .description img', '.js-full-width-product-images');
    }

    if ($('.js-product-gallery').hasClass('single-image')){
      draggable = false;
      prevNextButtons = false;
    }

    if(is_touch_device() && $('.js-product-gallery').hasClass('popup-enabled--false')) {
      imageFunctions.zoom('.js-product-gallery');
      draggable = false;
    } else {
      imageFunctions.zoom('.js-product-gallery', false);
    }

    
    if (!$('.js-product-gallery').hasClass('single-image')){
      $('.js-product-gallery').flickity({
        "adaptiveHeight": true,
        "wrapAround": "true",
        "cellAlign": "left",
        "draggable": draggable,
        "contain": true,
        "imagesLoaded": true,
        "lazyLoad": 2,
        "pageDots": false,
        "prevNextButtons": prevNextButtons,
        "autoPlay": autoplay ? 6000 : false,
        "dragThreshold": 10,
        "arrowShape": arrowSize
      });
    }

    var groupCells = true;
    var navPrevNextButtons = false;
    var navCellAlign = "center";
    var navWrapAround = false;

    if ($('.product_gallery_nav .gallery-cell').length >= 7) {
      groupCells = false;
      navPrevNextButtons = true;
      navCellAlign = "left";
      navWrapAround = true;
    }

    $('.product-template .product_gallery_nav.product_gallery_nav--bottom-slider').flickity({
      "asNavFor": ".product_gallery",
      "adaptiveHeight": false,
      "wrapAround": navWrapAround,
      "cellAlign": "center",
      "draggable": true,
      "groupCells": groupCells,
      "prevNextButtons":  navPrevNextButtons,
      "pageDots": false,
      "lazyLoad": 2,
      "dragThreshold": 10,
      "arrowShape": arrowSize
    });

    $(".js-product_section .product_form_options").each(function() {
      new Shopify.OptionSelectors($(this).data("select-id"), { product: $(this).data("product"), onVariantSelected: selectCallback, enableHistoryState: $(this).data("enable-state") });
    });

    if (window.location.search === '?contact_posted=true') {
      $('.notify_form .contact-form').hide();
      $('.notify_form .contact-form').prev('.message').html("Thanks! We will notify you when this product becomes available!");
    }

    var $notify_form = $('.notify_form .contact-form');
    $notify_form.each(function() {
      var $nf = $(this);
      $nf.on("submit", function (e) {
        if($('input[name="challenge"]', $nf).val() !== "true") {
          $.ajax({
            type: $nf.attr('method'),
            url: $nf.attr('action'),
            data: $nf.serialize(),
            success: function (data) {
              $nf.fadeOut("slow", function(){
                $nf.prev('.message').html("Thanks! We will notify you when this product becomes available!");
              });
            },
            error: function(data) {
              $('input[name="challenge"]', $nf).val('true');
              $nf.submit();
            }
          });
          e.preventDefault();
        }
      });
    });

    
      $('body').on('change', '.swatch :radio', function() {
        var optionIndex = $(this).closest('.swatch').attr('data-option-index');
        var optionValue = $(this).val();
        var parentForm = $(this).closest('.product_form form');


        if (parentForm.siblings('.notify_form').length){
          var notifyForm = parentForm.siblings('.notify_form');
        } else {
          var notifyForm = $('.js-notify-form');
        }

        var option1 = parentForm.find('.swatch_options input:checked').eq(0).val();
        var option2 = parentForm.find('.swatch_options input:checked').eq(1).val() || '';
        var option3 = parentForm.find('.swatch_options input:checked').eq(2).val() || '';

        if (option1 && option2 && option3){
          var notifyMessage = option1 + ' / ' + option2 + ' / ' + option3;
        } else if (option1 && option2){
          var notifyMessage = option1 + ' / ' + option2;
        } else {
          var notifyMessage = option1;
        }


        notifyForm.find(".notify_form_message").attr("value", notifyForm.find(".notify_form_message").data('body') + " - " + notifyMessage );

        $(this)
          .closest('form')
          .find('.single-option-selector')
          .eq(optionIndex)
          .val(optionValue)
          .trigger('change');
      });
    

    $('.js-product-gallery a').fancybox({
      baseClass: "product-section__lightbox",
      clickContent: false,
      afterShow: function(instance, slide) {
        const zoom = instance.$trigger.first().parents('.js-product-gallery').data('zoom');
        if (zoom){
          $('.fancybox-image')
              .wrap('<span class="zoom-wrap" style="display:inline-block"></span>')
              .css('display', 'block')
              .parent()
              .zoom({
                touch: false,
                magnify: 1
          });
        }
      },
      afterClose: function(instance, slide) {
        const $instanceGallery = instance.$trigger.first().parents('.js-product-gallery');
        $instanceGallery.hide();
        setTimeout(function(){
          $instanceGallery.fadeIn(100);
        }, 1);
      }
    });
    
  },
  productSwatches: function(){
    //Swatches linked with selected options
    
      if ($('.js-product_section').length){
        var $productForms = $('.js-product_section').find('.product_form');
        $productForms.addClass('is-visible');

        //Loop through each product and set the initial option value state

        $productForms.each(function(){
          var JSONData = $(this).data('product');
          var productID = $(this).data('product-id');
          var productSection = '.product-' + productID + ' .js-product_section';
          var swatchOptions = $(this).find('.swatch_options .swatch');
          if (swatchOptions.length > 1){
            Shopify.linkOptionSelectors(JSONData, productSection);
          }
        });
      }

      //Add click event when there is more than one product on the page (eg. Collection in Detail)
      if ($('.js-product_section').length > 1){
        $('body').on('click', '.swatch-element', function(){
          var swatchValue = $(this).data('value').toString();

          $(this)
          .siblings('input[value="'+ swatchValue.replace(/\"/g,'\\"') +'"]')
          .prop("checked", true)
          .trigger("change");

          var JSONData = $(this).parents('.product_form').data('product');
          var productID = $(this).parents('.product_form').data('product-id');
          var productSection = '.product-' + productID + ' .js-product_section';
          var swatchOptions = $(this).parents('.product_form').find('.swatch_options .swatch');

          if (swatchOptions.length > 1){
            Shopify.linkOptionSelectors(JSONData, productSection);
          }
        })
      }
    
  },
  relatedProducts: function(){

    $('.js-related-products-slider .products-slider').each(function (index, value) {
      var products_per_slide = $(this).data('products-per-slide');
      var products_limit = $(this).data('products-limit');
      var products_available = $(this).data('products-available');
      var cellAlign,
          draggable,
          prevNext,
          wrapAround,
          initialIndex;

      if (products_per_slide == "2" && products_available > products_per_slide && products_limit > products_per_slide || products_per_slide == "4" && products_available > products_per_slide && products_limit > products_per_slide || products_per_slide == "6" && products_available > products_per_slide && products_limit > products_per_slide){
        cellAlign = "left";
      } else {
        cellAlign = "center";
      }

      if (products_available > products_per_slide && products_limit > products_per_slide) {
        draggable = true;
        prevNext = true;
        wrapAround = true;
      } else {
        draggable = false;
        prevNext = false;
        wrapAround = false;
      }

      if (products_per_slide == "2" && products_available > products_per_slide || products_per_slide == "4" && products_available > products_per_slide || products_per_slide == "6" && products_available > products_per_slide){
        initialIndex = 0;
      } else if (products_per_slide == "3" && products_available) {
        initialIndex = 1;
      } else if (products_per_slide == "5" && products_available) {
        initialIndex = 2;
      } else if (products_per_slide == "7" && products_available) {
        initialIndex = 3;
      }

      if ($(window).width() <= 798) {
        cellAlign = "center";
        draggable = true;
        prevNext = true;
        wrapAround = true;
        initialIndex = 1;

        $(this).parents('.even-num-slides').removeClass('even-num-slides');
      }

      $(this).flickity({
        "lazyLoad": 2,
        "imagesLoaded": true,
        "draggable": draggable,
        "cellAlign": cellAlign,
        "prevNextButtons": prevNext,
        "wrapAround": wrapAround,
        "pageDots": usePageDots,
        "contain": true,
        "freeScroll": true,
        "arrowShape": arrowSize,
        "initialIndex": initialIndex
      });
    });
  },
  initializeQuantityBox: function(){

    $('body').on('click', '.js-change-quantity', function() {
        var $this = $(this),
            $input = $(this).siblings('input'),
            val = parseInt($input.val()),
            valMax = 100000000000000000000000000000,
            valMin = $input.attr('data-increments') || 0,
            increment = parseInt($input.attr('data-increments')) || 1;

        if ($input.attr('max') != null){
          valMax = $input.attr('max');
        }

        if(isNaN(val) || val < valMin) {
            $input.val(valMin);
            return false;
        } else if (val > valMax) {
            $input.val(valMax);
            return false;
        }
      
        if($this.data('func') == 'plus') {
            if(val < valMax) $input.val(val + increment);
        } else {
            if(val > valMin) $input.val(val - increment);
            if($this.parents(".cart_item").length || $this.parents('.cart-line-item').length) {
              if ((val - increment) <= 0) {
                //$this.closest('.cart_item').addClass('animated fadeOutUp')
                $input.val(0);
              }
            }
          if($this.parents('.qo-qty').length){
            if ((val - increment) <= 0) {
              $input.val(0);
            }
          }
        }
        $input.trigger('change');

    });
  },
  unload: function($target){

    var $slider = $target.find('.products-slider');
    $slider.flickity('destroy');

  }
}

/*============================================================================
  Header
==============================================================================*/

var header = {
  init: function(){

    var closeDropdown = function() {
      $('body').removeClass('is-active');
      $('.dropdown_link').removeClass('active_link');
      $('.dropdown_container').hide();
      $('.mobile_nav').find('div').removeClass('open');
    };

    var closeMiniCart = function() {
      $('body').removeClass('is-active').removeClass('blocked-scroll');
      $('.dropdown_link').toggleClass('active_link');
      $('.cart_container').removeClass('active_link');
    };

    var openMiniCart = function($cart_container) {
      $('body').addClass('blocked-scroll');
      $('.mobile_nav div').removeClass('open');
      $('.dropdown_link').removeClass('active_link');
      $cart_container.addClass('active_link');
    };

    //Vertical menu enabled
    if ($('.dropdown_link--vertical').length){
      $('.dropdown_link--vertical, .vertical-menu_submenu').on('mouseover', function(e) {
        var $dropdown = $(this).parents('.main_nav').find('[data-dropdown="' + $(this).data('dropdown-rel') + '"]');
        var clickCount = $(this).attr('data-click-count');

        $('.active_link').removeClass('active_link');
        if(!$(this).hasClass('active_link')) {
          $(this).children('a').addClass('active_link');
          $('.is-absolute').parent().removeClass('feature_image');
        }
      });

      //Enable touch on parent link if on touch device and desktop menu is visible
      if(is_touch_device()){
        $('.vertical-menu .sublink a, .vertical-menu_submenu .sublink a').on('touchstart click', function(e) {
          e.stopPropagation();

          var verticalMenu = $(this);

          if(e.type == "touchstart") {
            clicked = true;
            if($(this).attr('data-click-count') < 1) {
              openDropdown(verticalMenu);
              e.preventDefault();
            }
          }
          else if(e.type == "click" && !clicked) {
            if($(this).attr('data-click-count') < 1) {
              openDropdown(verticalMenu);
              e.preventDefault();
            }
          }
          else {
            clicked = false;
          }

          function openDropdown(verticalMenu) {

            var $dropdownMegaMenu = $(verticalMenu).parents('.main_nav').find('[data-dropdown="' + $(this).data('dropdown-rel') + '"]');
            var $dropdownVertical = $(verticalMenu).next('.vertical-menu_submenu');
            var clickCount = $(verticalMenu).attr('data-click-count');

            $('.dropdown_link--vertical').not(verticalMenu).attr('data-click-count', 0);
            $('.dropdown_link--vertical').attr('data-no-instant', true);
            $('.dropdown_container').hide();

            $dropdownMegaMenu.show();
            $('.vertical-menu_submenu').removeClass('is-visible');
            $dropdownVertical.addClass('is-visible');

            //capture touch event
            if (e.type == 'touchstart'){
              clickCount++;
              $(verticalMenu).attr('data-click-count', clickCount);

              if (clickCount < 2){
                e.preventDefault();
                e.stopPropagation();
                return false;
              }
            }
          }
        });
      }
    }

    if ($('.promo_banner').length){
      var promo_banner = Cookies.get('promo_banner');

      if (promo_banner != 'dismiss') {
        $('body').addClass('promo_banner-show');
        $('.promo_banner').on('click', '.promo_banner-close', function(){
          $('body').removeClass('promo_banner-show');
          Cookies.set('promo_banner', 'dismiss', { expires: 30 });
        });
      }
    }

    //offscreen check for menu
    $('.vertical-menu_submenu, .vertical-menu_sub-submenu').each(function() {
      if($(this).is(':off-right')) {
        $(this).addClass('vertical-menu--align-right');
      }
    });

    //Click anywhere outside of dropdown to close
    $('html').on('click', function(event) {
      if (!$(event.target).closest('.cart_container').length && $('.cart_content').is(':visible')) {

        closeMiniCart();
      }

      if (!$(event.target).closest('.dropdown_container').length && $('.dropdown').is(':visible')) {

        closeDropdown();
      }

    });

    //Only apply on larger screen sizes
    if ($(window).width() > 798) {
      if ($('.header').hasClass('header-fixed--true')){

        //offset scroll position
        $('body').on('click', '.banner a[href^="#"]', function(e) {
            e.preventDefault();
            var anchorLink = $(this).attr('href');
            var headerHeight = $('.main_nav_wrapper.sticky_nav').outerHeight();
            $('html, body').animate({
              scrollTop: $(anchorLink).offset().top - headerHeight
            }, 2000);
        });

        if (!$('.main_nav_wrapper').hasClass('sticky_nav')) {
          var sticky_nav = new Headhesive('.main_nav_wrapper', {
            offset: 700,
            throttle: 300,
            classes: {
              clone: 'sticky_nav',
              stick: 'sticky_nav--stick',
              unstick: 'sticky_nav--unstick'
            },
            onInit: function() {
              $(".sticky_nav .secondary_logo").css('display', 'none');
              $(".sticky_nav .primary_logo").css('display', 'block');
              $(".sticky_nav .icon-search").css('display', 'block');
              $(".sticky_nav .search_container").css('display', 'none');
              $(".sticky_nav .nav:last").prepend($(".header .cart_container").clone());
              
                var sticky_nav_height = $(".sticky_nav .nav").height() + 5;
              
              $(".sticky_nav .mini_cart").css("height", $(".sticky_nav").height() + 5);
              $(".sticky_nav .cart_content").css("top", $(".sticky_nav").height());
            },
            onUnstick: function() {
              $('.cart_container').removeClass('active_link');
            }
          });
        }
      } else {
        $('.header-fixed--true').removeClass('header-fixed--true');
        if ($('.main_nav_wrapper').length > 1) {
          $('.main_nav_wrapper').first().remove();
        }
      }

      if ($('img.primary_logo:visible')){
        $('.logo img', $(".feature_image .header")).attr('src', $('.logo img').data('src-home'));
      } else {
        $('.logo img').attr('src', $('.logo img').data('src'));
      }
    //Mobile menu
    } else {
      if ($('#header').hasClass('mobile_nav-fixed--true')){
        $('body').addClass('mobile_nav-fixed--true');

        //offset scroll position
        $('body').on('click', '.banner a[href^="#"]', function(e) {
            e.preventDefault();
            var anchorLink = $(this).attr('href');
            var headerHeight = $('#header').outerHeight();
            $('html, body').animate({
              scrollTop: $(anchorLink).offset().top - headerHeight
            }, 2000);
        });
      } else {
        $('body').addClass('mobile_nav-fixed--false');
      }
    }

    //avoid cart_content duplicating
    if($('.cart_content').length <= 2) {
      $('#header .cart_container').append($('.cart_content').clone());
    }

    if ( is_touch_device() || $(window).width() <= 798 ) {

      $('.dropdown_link').attr('data-no-instant', true);

      $('body').on('click', '.dropdown_link', function(e) {
        $('.nav a').removeClass('active_link');

        if ($('#header').is(':visible')) {
          var $dropdown = $(this).parents("#header").find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]')

            if(!$(this).hasClass('mini_cart')) {
              $('.cart_container').removeClass('active_link');
            }

        } else {

          if($(this).hasClass("icon-search")) {
            window.location = $(this).attr("href");
            return false;
          }

          var $dropdown = $(this).parents(".main_nav").find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]')
        }

        if ($dropdown.is(':visible') || $dropdown.attr('class') === undefined) {
          $dropdown.hide();
          $('body').removeClass('is-active');
        } else {
          $('.dropdown_container').hide();
          if(!$(this).hasClass('cart_container')) {
            $('.is-absolute').parent().removeClass('feature_image');
          }
          $dropdown.show();
          $('body').addClass('is-active');
          $('.mobile_nav').find('div').removeClass('open');
        }

        if ($dropdown.is(':visible')) {
          e.stopPropagation();
          return false;
        }
      });

      $('body').on("click", '.mobile_nav', function() {
        $(this).find('div').toggleClass('open');
      });

      //Toggle mini-cart with menu icon
      $(".mini_cart").on("click", function(e) {
        var $cart_container = $(this).parent();
        if($cart_container.hasClass('active_link')) {
          closeMiniCart();
          $('body').removeClass('blocked-scroll');
        } else {
          openMiniCart($cart_container);
          $('body').addClass('blocked-scroll');
        }

        if (is_touch_device() || $(window).width() <= 798) {
          e.preventDefault();
        }
      });

      $('.cart_content__continue-shopping').on('click', function(e){
        closeMiniCart();
      })

    } else {

      $(".nav a, .logo a").not(".cart_content a").on("mouseenter", function() {
        if(!$(this).hasClass("active_link")) {
          $('.dropdown_container').hide();
          $('.active_link').removeClass('active_link');
          $('.is-absolute').parent().addClass('feature_image');
        }
      });

      $('.main_nav, .top_bar, .cart_container').on("mouseleave", function() {
        if ( $(window).width() > 798) {
          $('.dropdown_container').hide();
        }
        $('.active_link').removeClass('active_link');
        $('.is-absolute').parent().addClass('feature_image');
      });

      $('.dropdown_link, .dropdown_link--vertical').attr('data-click-count', 0);

      $('.dropdown_link').on('mouseover touchstart', function(e) {
        if ( $(window).width() > 798) {
          $('.dropdown_container').hide();
        }

        var $dropdown = $(this).parents('.main_nav').find('[data-dropdown="' + $(this).data('dropdown-rel') + '"]');
        var clickCount = $(this).attr('data-click-count');

        $('.active_link').removeClass('active_link');

        if(!$(this).hasClass('active_link')) {
          $dropdown.show();

          if($(this).hasClass('mini_cart')) {
            $(this).parent('.cart_container').addClass('active_link');
          } else {
            if ( $(window).width() > 798) {
              $(this).addClass('active_link');
            }
            $('.is-absolute').parent().removeClass('feature_image');
          }
        }

        //Enable touch on parent link if on touch device and desktop menu is visible
        if(is_touch_device()){
          $('.dropdown_link').not(this).attr('data-click-count', 0);
          $('.dropdown_link').attr('data-no-instant', true);


          //capture touch event
          if (e.type == 'touchstart'){
            clickCount++;
            $(this).attr('data-click-count', clickCount);

            if (clickCount < 2){
              e.preventDefault();
              e.stopPropagation();
              return false;
            }
          }
        }

      });

    }

  },
  removeDataAttributes: function(target){
    if($(target).length){
      var i,
          $target = $(target),
          attrName,
          dataAttrsToDelete = [],
          dataAttrs = $target.get(0).attributes,
          dataAttrsLen = dataAttrs.length;

      for (i=0; i<dataAttrsLen; i++) {
        if ( 'data-' === dataAttrs[i].name.substring(0,5) ) {
          dataAttrsToDelete.push(dataAttrs[i].name);
        }
      }
      $.each( dataAttrsToDelete, function( index, attrName ) {
        $target.removeAttr( attrName );
      })
    }
  },
  loadMegaMenu: function(){

    //Remove old mega-menus so that theme-editor works properly
    $('.sticky_nav .mega-menu').remove();
    $('.header .mega-menu').remove();

    //Clone the mega menu from section into sticky_nav
    $('.mega-menu-container .mega-menu')
      .clone()
      .appendTo('.sticky_nav .main_nav');
    //Remove theme-editor data-attributes
    header.removeDataAttributes('.sticky_nav .mega-menu.dropdown_container .dropdown_column');

    //Loop through mega-menus to add arrow to parent
    $('.mega-menu-container .mega-menu').each(function(index){
      var megaMenuValue = $(this).data("dropdown");
      $('[data-dropdown-rel="' + megaMenuValue + '"]')
        .find('span')
        .remove();

      $('[data-dropdown-rel="' + megaMenuValue + '"]')
        .not('.icon-search')
        .append(' <span class="icon-down-arrow"></span>')
        .addClass('mega-menu-parent')
        .addClass('dropdown_link')
        .removeClass('top_link');

      $('[data-dropdown="' + megaMenuValue + '"]').each(function(index){
        if (!$(this).hasClass('mega-menu')) {
          $(this).remove();
        }
      });

      $(this).clone().appendTo('.header .main_nav');
    });

    //Remove default mega menus if vertical menus are selected
    if ($('.dropdown_link--vertical').length){
      $('.dropdown_link--vertical.mega-menu-parent + .vertical-menu_submenu').remove();
      $('.dropdown_link--vertical:not(.mega-menu-parent)').each(function(index){
        var megaMenuValue = $(this).data('dropdown-rel');
        $('[data-dropdown="' + megaMenuValue + '"]').remove();
      })
    }

    $('.mega-menu-parent').on('mouseenter', function() {

      if(!$(this).hasClass('active_link')) {
        $('.dropdown_container').hide();
        $(this).parents('.main_nav').find('[data-dropdown="' + $(this).data('dropdown-rel') + '"]').toggle();

        $(this).addClass('active_link');
        $('.is-absolute').parent().removeClass('feature_image');

      }
    });

    //Remove theme-editor data-attributes
    header.removeDataAttributes('.header .mega-menu.dropdown_container .dropdown_column');

    if (is_touch_device() || $(window).width() <= 798) {
      $('.dropdown_link').attr('data-no-instant', true);
    }

    header.loadMobileMegaMenu();
  },
  loadMobileMegaMenu: function() {

    //Loop through mega menus and add to mobile menu
    $('.mega-menu-container .mobile-mega-menu').each(function(index){
      $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').find('span').remove();
      $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"] > a').append(' <span class="right icon-down-arrow"></span>').attr('data-no-instant', 'true');
      $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').addClass('mobile-mega-menu-parent sublink');
      $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').append(this);
      $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"] > ul').each(function(index){
        if (!$(this).hasClass('mobile-mega-menu')) {
          $(this).remove();
        }
      });
    });
  },
  unloadMegaMenu: function(){
    $('.header .mega-menu').remove();
    $('.mega-menu-container .mega-menu').each(function(index){
      var menuParent = $(this).data('dropdown');
      $('.mega-menu-parent[data-dropdown-rel="' + $(this).data("dropdown") + '"]').find('.icon-down-arrow').remove();
    });
  },
  unload: function() {
    $('body').off('click', '.mobile_nav');
    $('body').off('click', '.dropdown_link');
    $('html').off('click');
    $('.mini_cart').off('click');
    $('.cart_content__continue-shopping').off('click');
    $('body').off('click', '.banner a[href^="#"]');
  }
}

/*============================================================================
  Social media
==============================================================================*/

  var social = {
    twitter: function(){
      if ($('.twitter-timeline').length) {
        if (!window.twttr) {
          //Initialize twitter feed
          window.twttr = (function (d,s,id) {
          var t, js, fjs = d.getElementsByTagName(s)[0];
          if (d.getElementById(id)) return; js=d.createElement(s); js.id=id;
          js.src="https://platform.twitter.com/widgets.js";
          fjs.parentNode.insertBefore(js, fjs);
          return window.twttr || (t = { _e: [], ready: function(f){ t._e.push(f) } });
          }(document, "script", "twitter-wjs"));
        } else {
          window.twttr.ready(function (twttr) {
            twttr.widgets.load(
              document.getElementById("twitter-timeline")
            );
          });
        }
      }
    },
    unload: function(){
    }
  }

  var instagram = {
    loadContent: function(s){
      if(s.clientID) {
        var url = 'https://api.instagram.com/v1/users/self/media/recent/?access_token='+s.clientID;

        $.ajax({
          type: 'GET',
          url: url,
          dataType: 'jsonp',
          success: function(data) {

            if(data.meta.code === 200 && data.data.length) {
              var data = data.data;
              var count = 0;
              s.el.empty();

              for(var i = 0; i < data.length; i++) {
                var thisMedia = data[i], item;

                var url = thisMedia.images.low_resolution.url;

                if(!thisMedia.images.low_resolution.url.indexOf("null") > -1) {
                  item = '<div class="il-photo__img instagram__bg" style="background-image:url('+url+')" data-filter="'+thisMedia.filter+'" /></div>';
                  item = '<a href="'+thisMedia.link+'" target="_blank" class="instagram__link">'+item+'</a>';
                }

                if(thisMedia.videos) {
                  item = '<div class="instagram__video instagram__bg" style="background-image:url('+url+')" data-filter="'+thisMedia.filter+'" /></div>';
                  item = '<a href="'+thisMedia.link+'" target="_blank" class="instagram__link instagram__video-link">'+item+'</a>';
                }

                if(item) {
                  item = '<div class="'+s.column+ ' columns instagram__item small-down--one-whole">'+item+'</div>';
                }
                if(item !== '') {
                  s.el.append(item);
                  count++;
                }
                if(count == s.limit) {
                  break;
                }
              }
            }
          },
          error: function() {
          }
        });
      }
    }
  }

  $('.social-feeds-wrap').each(function (index, value) {

    social.twitter();

    var $target = $(this).find(".js-instafeed");
    instagram.loadContent({
      el: $target,
      clientID: $target.data('client-id'),
      limit: $target.data('count'),
      column: $target.data('column')
    });
  });

/*============================================================================
  Map
==============================================================================*/
var mapFunction = {
  init: function() {

    if($('.lazymap').length > 0){
      lazyframe('.lazymap');
    }

    if ($('.maps').hasClass('js-api-map')) {
      var mapsToLoad = [];
      //Create map settings array
      $('.map').each(function(i, obj) {
        mapsToLoad.push(this);
        mapsToLoad[i].sectionid = $(this).data('id');
        mapsToLoad[i].address = $(this).data('address');
        mapsToLoad[i].directions = $(this).data('directions-address');
        mapsToLoad[i].zoom = $(this).data('zoom');
        mapsToLoad[i].mapstyle = $(this).data('style');
        mapsToLoad[i].showpin = $(this).data('pin');
        mapsToLoad[i].apikey = $(this).data('api-key');
      });
      $.each(mapsToLoad, function(i, instance) {
        //Enable caching to avoid duplicate google maps files
        $.ajaxSetup({ cache: true });
        //Load maps script and find location coordinates
        $.getScript(
          'https://maps.googleapis.com/maps/api/js?key=' + mapsToLoad[i].apikey
        ).then(function() {
          mapFunction.findLocation(mapsToLoad[i]);
          $.ajaxSetup({ cache: false });
        });
      });
    }
  },
  findLocation: function(mapArray) {
    var geoLat;
    var geoLng;
    var geocoder = new google.maps.Geocoder();
    //Find and set coordinates
    geocoder.geocode({ address: mapArray.address }, function(results, status) {
      if (status == google.maps.GeocoderStatus.OK) {
        geoLat = results[0].geometry.location.lat();
        geoLng = results[0].geometry.location.lng();
        //Create map
        mapFunction.initMap(geoLat, geoLng, mapArray);
      } else {
        console.log('Error:' + status);
      }
    });
  },
  initMap: function(lat, lng, mapArray) {
    var location = { lat: lat, lng: lng };
    var styleJson = [];
    //Set style JSON
    if(mapArray.mapstyle=='aubergine'){
      styleJson=[{elementType:'geometry',stylers:[{color:'#1d2c4d'}]},{elementType:'labels.text.fill',stylers:[{color:'#8ec3b9'}]},{elementType:'labels.text.stroke',stylers:[{color:'#1a3646'}]},{featureType:'administrative.country',elementType:'geometry.stroke',stylers:[{color:'#4b6878'}]},{featureType:'administrative.land_parcel',elementType:'labels.text.fill',stylers:[{color:'#64779e'}]},{featureType:'administrative.province',elementType:'geometry.stroke',stylers:[{color:'#4b6878'}]},{featureType:'landscape.man_made',elementType:'geometry.stroke',stylers:[{color:'#334e87'}]},{featureType:'landscape.natural',elementType:'geometry',stylers:[{color:'#023e58'}]},{featureType:'poi',elementType:'geometry',stylers:[{color:'#283d6a'}]},{featureType:'poi',elementType:'labels.text.fill',stylers:[{color:'#6f9ba5'}]},{featureType:'poi',elementType:'labels.text.stroke',stylers:[{color:'#1d2c4d'}]},{featureType:'poi.park',elementType:'geometry.fill',stylers:[{color:'#023e58'}]},{featureType:'poi.park',elementType:'labels.text.fill',stylers:[{color:'#3C7680'}]},{featureType:'road',elementType:'geometry',stylers:[{color:'#304a7d'}]},{featureType:'road',elementType:'labels.text.fill',stylers:[{color:'#98a5be'}]},{featureType:'road',elementType:'labels.text.stroke',stylers:[{color:'#1d2c4d'}]},{featureType:'road.highway',elementType:'geometry',stylers:[{color:'#2c6675'}]},{featureType:'road.highway',elementType:'geometry.stroke',stylers:[{color:'#255763'}]},{featureType:'road.highway',elementType:'labels.text.fill',stylers:[{color:'#b0d5ce'}]},{featureType:'road.highway',elementType:'labels.text.stroke',stylers:[{color:'#023e58'}]},{featureType:'transit',elementType:'labels.text.fill',stylers:[{color:'#98a5be'}]},{featureType:'transit',elementType:'labels.text.stroke',stylers:[{color:'#1d2c4d'}]},{featureType:'transit.line',elementType:'geometry.fill',stylers:[{color:'#283d6a'}]},{featureType:'transit.station',elementType:'geometry',stylers:[{color:'#3a4762'}]},{featureType:'water',elementType:'geometry',stylers:[{color:'#0e1626'}]},{featureType:'water',elementType:'labels.text.fill',stylers:[{color:'#4e6d70'}]}]
    }else if(mapArray.mapstyle=='retro'){
      styleJson=[{elementType:'geometry',stylers:[{color:'#ebe3cd'}]},{elementType:'labels.text.fill',stylers:[{color:'#523735'}]},{elementType:'labels.text.stroke',stylers:[{color:'#f5f1e6'}]},{featureType:'administrative',elementType:'geometry.stroke',stylers:[{color:'#c9b2a6'}]},{featureType:'administrative.land_parcel',elementType:'geometry.stroke',stylers:[{color:'#dcd2be'}]},{featureType:'administrative.land_parcel',elementType:'labels.text.fill',stylers:[{color:'#ae9e90'}]},{featureType:'landscape.natural',elementType:'geometry',stylers:[{color:'#dfd2ae'}]},{featureType:'poi',elementType:'geometry',stylers:[{color:'#dfd2ae'}]},{featureType:'poi',elementType:'labels.text.fill',stylers:[{color:'#93817c'}]},{featureType:'poi.park',elementType:'geometry.fill',stylers:[{color:'#a5b076'}]},{featureType:'poi.park',elementType:'labels.text.fill',stylers:[{color:'#447530'}]},{featureType:'road',elementType:'geometry',stylers:[{color:'#f5f1e6'}]},{featureType:'road.arterial',elementType:'geometry',stylers:[{color:'#fdfcf8'}]},{featureType:'road.highway',elementType:'geometry',stylers:[{color:'#f8c967'}]},{featureType:'road.highway',elementType:'geometry.stroke',stylers:[{color:'#e9bc62'}]},{featureType:'road.highway.controlled_access',elementType:'geometry',stylers:[{color:'#e98d58'}]},{featureType:'road.highway.controlled_access',elementType:'geometry.stroke',stylers:[{color:'#db8555'}]},{featureType:'road.local',elementType:'labels.text.fill',stylers:[{color:'#806b63'}]},{featureType:'transit.line',elementType:'geometry',stylers:[{color:'#dfd2ae'}]},{featureType:'transit.line',elementType:'labels.text.fill',stylers:[{color:'#8f7d77'}]},{featureType:'transit.line',elementType:'labels.text.stroke',stylers:[{color:'#ebe3cd'}]},{featureType:'transit.station',elementType:'geometry',stylers:[{color:'#dfd2ae'}]},{featureType:'water',elementType:'geometry.fill',stylers:[{color:'#b9d3c2'}]},{featureType:'water',elementType:'labels.text.fill',stylers:[{color:'#92998d'}]}]
    }else if(mapArray.mapstyle=='silver'){
      styleJson=[{elementType:'geometry',stylers:[{color:'#f5f5f5'}]},{elementType:'labels.icon',stylers:[{visibility:'off'}]},{elementType:'labels.text.fill',stylers:[{color:'#616161'}]},{elementType:'labels.text.stroke',stylers:[{color:'#f5f5f5'}]},{featureType:'administrative.land_parcel',elementType:'labels.text.fill',stylers:[{color:'#bdbdbd'}]},{featureType:'poi',elementType:'geometry',stylers:[{color:'#eeeeee'}]},{featureType:'poi',elementType:'labels.text.fill',stylers:[{color:'#757575'}]},{featureType:'poi.park',elementType:'geometry',stylers:[{color:'#e5e5e5'}]},{featureType:'poi.park',elementType:'labels.text.fill',stylers:[{color:'#9e9e9e'}]},{featureType:'road',elementType:'geometry',stylers:[{color:'#ffffff'}]},{featureType:'road.arterial',elementType:'labels.text.fill',stylers:[{color:'#757575'}]},{featureType:'road.highway',elementType:'geometry',stylers:[{color:'#dadada'}]},{featureType:'road.highway',elementType:'labels.text.fill',stylers:[{color:'#616161'}]},{featureType:'road.local',elementType:'labels.text.fill',stylers:[{color:'#9e9e9e'}]},{featureType:'transit.line',elementType:'geometry',stylers:[{color:'#e5e5e5'}]},{featureType:'transit.station',elementType:'geometry',stylers:[{color:'#eeeeee'}]},{featureType:'water',elementType:'geometry',stylers:[{color:'#c9c9c9'}]},{featureType:'water',elementType:'labels.text.fill',stylers:[{color:'#9e9e9e'}]}]
    }else if(mapArray.mapstyle=='night'){
      styleJson=[{elementType:'geometry',stylers:[{color:'#242f3e'}]},{elementType:'labels.text.fill',stylers:[{color:'#746855'}]},{elementType:'labels.text.stroke',stylers:[{color:'#242f3e'}]},{featureType:'administrative.locality',elementType:'labels.text.fill',stylers:[{color:'#d59563'}]},{featureType:'poi',elementType:'labels.text.fill',stylers:[{color:'#d59563'}]},{featureType:'poi.park',elementType:'geometry',stylers:[{color:'#263c3f'}]},{featureType:'poi.park',elementType:'labels.text.fill',stylers:[{color:'#6b9a76'}]},{featureType:'road',elementType:'geometry',stylers:[{color:'#38414e'}]},{featureType:'road',elementType:'geometry.stroke',stylers:[{color:'#212a37'}]},{featureType:'road',elementType:'labels.text.fill',stylers:[{color:'#9ca5b3'}]},{featureType:'road.highway',elementType:'geometry',stylers:[{color:'#746855'}]},{featureType:'road.highway',elementType:'geometry.stroke',stylers:[{color:'#1f2835'}]},{featureType:'road.highway',elementType:'labels.text.fill',stylers:[{color:'#f3d19c'}]},{featureType:'transit',elementType:'geometry',stylers:[{color:'#2f3948'}]},{featureType:'transit.station',elementType:'labels.text.fill',stylers:[{color:'#d59563'}]},{featureType:'water',elementType:'geometry',stylers:[{color:'#17263c'}]},{featureType:'water',elementType:'labels.text.fill',stylers:[{color:'#515c6d'}]},{featureType:'water',elementType:'labels.text.stroke',stylers:[{color:'#17263c'}]}]}else{styleJson=[]}
    //Create google maps link
    $('.js-map-link').attr(
      'href',
      'https://www.google.com/maps/place/' +
        mapArray.directions +
        '/@' +
        lat +
        ',' +
        lng
    );
    //Set map options
    var mapOptions = {
      zoom: mapArray.zoom,
      center: location,
      styles: styleJson,
      disableDefaultUI: false
    };
    //Create map
    var map = new google.maps.Map(
      document.getElementById(mapArray.sectionid),
      mapOptions
    );
    //Show pin
    if (mapArray.showpin == true) {
      var marker = new google.maps.Marker({
        position: location,
        map: map
      });
    }
  }
};

/*============================================================================
  FAQ
==============================================================================*/
var faqAccordion = {
  init: function(){
    var flg = 0;
    var $faqHeading = $('.faqAccordion > dt > button');
    $('.faqAccordion > dd').attr('aria-hidden',true);
    $faqHeading.attr('aria-expanded',false);
    $faqHeading.on('click activate',function(){
      if( flg ) return false;
      flg = 1;
      var state = $(this).attr('aria-expanded') === 'false' ? true : false;
      $(this).attr('aria-expanded',state);
      $(this).parent().next().slideToggle(function(){
        flg = 0;
      });
        $(this).parent().next().attr('aria-hidden',!state);
      return false;
    });
    $faqHeading.on('keydown',function(event){
      var keyCode = event.keyCode || e.which;
      if (keyCode === 13){
        $(this).trigger('activate');
      }
    });
  }
}

/*============================================================================
  Homepage Featured Products
==============================================================================*/

var homepageFeaturedProducts = {
  bottom_selector: ".featured-products-bottom",
  pixels_moved: 0,
  section_activated: false,
  init: function(){
    var _this = this;
    _this.setListeners();
  },
  setListeners: function(){
    var _this = this;
    if($('.featured-products-bottom').length > 0 && $(window).width() > 798){
      $(window).on('scroll',function(){      
        _this.setNewHeight();
      });    
    }
  },
  setNewHeight: function(){
    var _this = this;
    
    if(_this.section_activated === false){
      _this.activateSection();      
    }
  },
  activateSection: function(){
    var _this = this;
    _this.section_activated = true;
    $(window).unbind('scroll');
    $('.featured-products-container').animate({"height":"20vw"},800,function(){
      $('.featured-products-container').animate({"opacity":"1"},200);
    });
  }
}
  



/*============================================================================
  Homepage Logins
==============================================================================*/

var homepageLogin = {
  login_form_height: 0,
  login_active: false,  
  init: function(){
    var _this = this;
    _this.setFormHeight();
    _this.setListeners();
  },
  setFormHeight: function(){
    var _this = this;
    _this.login_form_height = $('.home-login-form').height() + "px";
  },  
  setListeners: function(){
    var _this = this;
    $('body').on('keyup',function(e){
      if(e.keyCode === 13){
        if($(':focus').attr('id') === "customer_email" || $(':focus').attr('id') === "customer_password"){
          $('#customer_login').submit();
        }
      }
    });
    $('#openLogin').on('click',function(){
      if(_this.login_active ===  true){
        $('#customer_login').submit();        
      }else{
        _this.login_active = true;
        $('.home-login-form').css({
          "opacity": "1",
          "pointer-events": "all",
          "height": "auto"
        }); 
        $('#openLogin').css({"width":"100%"});
        $('#openLogin a').text("Enter");
        $('#recoverPassword, #back').addClass('active'); 
        $('#apply').removeClass('active');
      }          
    });
    $('#back').on('click',function(){
      _this.login_active = false;
      $('.home-login-form').css({
        "opacity": "0",
        "pointer-events": "none",
        "height": "0px"
      });   
      $('#openLogin').css({"width":"auto"});
      $('#openLogin a').text("Log In");
      $('#recoverPassword, #back').removeClass('active'); 
      $('#apply').addClass('active');      
    });
    $('#recoverPassword').on('click',function(){
      _this.login_active = false;
      $('.home-login-recover-password').css({
        "opacity": "1",
        "pointer-events": "all"
      }); 
      $('.home-login-form').css({
        "opacity": "0",
        "pointer-events": "none"
      });      
      $('#recoverPassword, #apply, #openLogin').removeClass('active');
      $('#closeRecoverPassword, #submitRecoverPassword').addClass('active');       
    });
    $('#closeRecoverPassword').on('click',function(){
      _this.login_active = true;
      $('.home-login-recover-password').css({
        "opacity": "0",
        "pointer-events": "none"      
      });
      $('.home-login-form').css({
        "opacity": "1",
        "pointer-events": "all"
      });       
      $('#closeRecoverPassword, #submitRecoverPassword').removeClass('active');
      $('#recoverPassword, #apply, #openLogin').addClass('active');
    });     
  }
}


/*============================================================================
  Countdown Timer
==============================================================================*/

var countdownTimer = {
  cutoffHour: 15,
  cutoff_seconds: (1100*60*60)/100,
  timer_selector: ".countdown-timer .time",
  init: function(){
    var _this = this;
    var date = new Date();
    if(date.getHours() < _this.cutoffHour){
      _this.incrementTimer();
    }else{
      $('.countdown-timer').css({"opacity": "1"});
    }
  },
  incrementTimer: function(){
    var _this = this;
    setTimeout(function(){
      var date = new Date();
      var seconds = date.getHours() * 60 * 60 + date.getMinutes() * 60 + date.getSeconds();
      var remaining = _this.cutoff_seconds - seconds;
      if(remaining <= 0){
        remaining = (24 * 60 * 60) + remaining;
      }      
      var remaining_seconds = parseInt(remaining % 60);
      var remaining_minutes = parseInt((remaining / 60) % 60);
      var remaining_hours = parseInt((remaining / 60 / 60));
      $(_this.timer_selector).text(remaining_hours+"h "+remaining_minutes+"m "+remaining_seconds+"s");
      $('.countdown-timer').css({"opacity": "1"});
      _this.incrementTimer();
    },1000);    
  }
}

/*============================================================================
  Collection Page
==============================================================================*/

var collectionPage = {
  initial_sidebar_top: 0,
  init: function(){
    var _this = this;
    //_this.initial_sidebar_top = $('.sidebar-wrap').offset().top;
    _this.setListeners();
    _this.activateSearchBar();
  },
  activateSearchBar: function(){
    if($('.header-big-search-bar').length > 0){
      var w = $('.product-list').width();
      var l = $('.product-list').offset().left;
      $('.header-big-search-bar').animate({
        "width": w,
        "left": l
      },100,function(){
        $('.header-big-search-bar').animate({
          "opacity": "1"
        }, 200);
      });
    }
  },
  setListeners: function(){
    var _this = this;
    var scrolling = false;
    if($('.header-big-search-bar').length > 0){
      $(window).resize(function(){
        _this.activateSearchBar();
      });
    }
    /*
    if($('.sidebar-wrap').length > 0){
      $(window).on('scroll',function(){   
        var top = $(document).scrollTop();      
        if($('.sidebar-wrap').offset().top < top && scrolling === false){
          var sidebar_top = top - _this.initial_sidebar_top + 100;
          scrolling = true;
          $('.sidebar-wrap').animate({"top":sidebar_top},2000,function(){
            scrolling = false;
          });
        }else{
          scrolling = true;
          $('.sidebar-wrap').animate({"top":"0px"},2000,function(){
            scrolling = false;
          });
        }
      });         
    }
    */
  }
}


/*============================================================================
  New Menu
==============================================================================*/
var menuSearch = {
  init: function(){
    var _this = this;
    this.setListeners();
  },
  setListeners: function(){
    var _this = this;
    $('.search_form').submit(function(e){
      if($('.away-page').length === 0 ){
        e.preventDefault();
        var search_term = $(this).find('input[name="q"]').val();
        console.log(search_term);
        _this.populateSearch("product",search_term);
      }
    });
    $('.search-submit').on('click',function(){
      var search_term = $(this).closest('form').find('input[name="q"]').val();
      _this.populateSearch("product",search_term);
    });
    if($('.sidebar-wrap').length > 0){
      $(window).on('scroll',function(){           
        if($('.sidebar-wrap').offset().top < 10){
          var top = $(document).scrollTop();
          $('.sidebar-wrap').css({"top":""})
        }
      });
    }    
  },
  populateSearch: function(type,search_term){
    var full_search_html = "<div class='search-link'><a href='/search?type="+type+"&q="+search_term+"*'>See All Results<div class='underline'></div></a></div>";
    $.get('/search?type='+type+'&q='+search_term+'*',function(res){
      $('.search-results').html($(res).find('.product-list'));
      $('.search-results').append(full_search_html);
    });
  }
}

var footer = {
  init: function(){
    var _this = this;
    _this.setColumnHeight();
    _this.setListeners();
  },
  setListeners: function(){
    var _this = this;
    $(window).resize(function(){
      _this.setColumnHeight();
    });  
  },
  setColumnHeight: function(){
    var _this = this;
    var tallest = 0;    
    $('.footer-menus-section').each(function(){
      if($(this).outerHeight() > tallest){
        tallest = $(this).outerHeight();
      }
    });
    $('.footer-section-content').each(function(){
      if($(this).outerHeight() > tallest){
        tallest = $(this).outerHeight();
      }
    }); 
    
    $('.footer-section-content, .footer-menus-section').css({
      "height":tallest+"px"
    });
  }
}

var navigation = {  
  menu_activator_selector: "#menu-toggle",
  cart_activator_selector: "#header-cart",
  search_activator_selector: "#header-search",
  menu_selector: ".menu-items-wrapper",
  cart_selector: ".cart-slide-wrapper",
  search_selector: ".search-slide-wrapper",
  logo_selector: ".menu-logo",
  menu_bg: ".menu-bg",
  init: function(){
    var _this = this;
    _this.setMenuHeights();
    _this.addMenuListeners();
  },
  setMenuHeights: function(){
    var menu_index = 0;
    $('a.has-children').each(function(){
      var menu = $(this).siblings('ul').first();
      if(menu.hasClass('menu-lvl-2')){
        menu.addClass('menu-'+menu_index);
        var items = menu.find('>li');
        var height = items.length * 34.4;
        $('<style>.menu-lvl-2.menu-'+menu_index+'.active { min-height: '+height+'px; height: unset; }</style>').appendTo('head');
      }
      if(menu.hasClass('menu-lvl-3')){
        menu.addClass('menu-'+menu_index);
        var items = menu.find('li');
        var height = items.length * 24.4;
        $('<style>.menu-lvl-3.menu-'+menu_index+'.active { min-height: '+height+'px; height: unset; }</style>').appendTo('head');
      } 
      menu_index++;
    });
  },
  toggleMainMenu: function(){
    var _this = this;
    if($(_this.menu_selector).hasClass("open")){
      _this.closeMainMenu();
    }else{
      _this.openMainMenu();      
    }
  },
  closeMainMenu: function(){
    var _this = this;
    var left = "-35%";
    if(screen.width < 798){
      left = "-90%";
    }
    var css_hidden = {
      "left": left,
      "opacity": "0"    
    }
    $(_this.menu_selector).css(css_hidden);
    $(_this.menu_selector).removeClass("open");
    $(_this.menu_activator_selector).removeClass('active');
    $(_this.menu_bg).removeClass('active'); 
    $(_this.logo_selector).show();
    $('.header-big-search-bar').css({"z-index":"12"});
    if(screen.width < 798){
      $("#header-search, #header-cart, #header-account").show();
    }      
  },
  openMainMenu: function(){
    var _this = this;
    var css_show = {
      "left": "0%",
      "opacity": "1"        
    }
    $(_this.menu_selector).css(css_show);
    $(_this.menu_selector).addClass("open");
    $(_this.menu_activator_selector).addClass('active');
    $(_this.menu_bg).addClass('active'); 
    $(_this.logo_selector).hide();
    $('.header-big-search-bar').css({"z-index":"8"});
    if(screen.width < 798){
      $("#header-search, #header-cart, #header-account").hide();
      _this.closeCartTray();
    }    
  },
  closeCartTray: function(){
    var _this = this;
    var right = "-20%";
    if(screen.width < 798){
      right = "-100%";
    }    
    var css_hidden = {
      "right": right,
      "opacity": "0"    
    }
    $(_this.cart_selector).css(css_hidden);
    $('.header-big-search-bar').css({"z-index":"12"}); 
    $(_this.search_selector).css(css_hidden).removeClass("open");
    $(_this.cart_selector).removeClass("open"); 
  },
  toggleCartTray: function(){
    var _this = this;
    var right = "-20%";
    if(screen.width < 798){
      right = "-80%";
    }    
    var css_hidden = {
      "right": right,
      "opacity": "0"    
    }
    var css_show = {
      "right": "0%",
      "opacity": "1"        
    }
    if($(_this.search_selector).hasClass("open")){
      $(_this.search_selector).css(css_hidden).removeClass("open");      
    }
    _this.closeMainMenu();
    if($(_this.cart_selector).hasClass("open")){
      $(_this.cart_selector).css(css_hidden);
      $('.header-big-search-bar').css({"z-index":"12"});
    }else{
      $(_this.cart_selector).css(css_show);
      $('.header-big-search-bar').css({"z-index":"8"});
    }
    $(_this.cart_selector).toggleClass("open");  
  },
  toggleSearchTray: function(){
    var _this = this;
    var right = "-33%";
    if(screen.width < 798){
      right = "-80%";
    }     
    var css_hidden = {
      "right": right,
      "opacity": "0"    
    }
    var css_show = {
      "right": "0%",
      "opacity": "1"        
    }
    if($(_this.cart_selector).hasClass("open")){
      $(_this.cart_selector).css(css_hidden).removeClass("open");      
    }
    _this.closeMainMenu();
    if($(_this.search_selector).hasClass("open")){
      $(_this.search_selector).css(css_hidden);
    }else{
      $(_this.search_selector).css(css_show);
    }
    $(_this.search_selector).toggleClass("open");  
  }, 
  openSearchTray: function(){
    var _this = this;
    if(screen.width < 798){      
      right = "-80%";
    }     
    var css_show = {
      "right": "0%",
      "opacity": "1"        
    }
    _this.closeMainMenu();
    $(_this.search_selector).css(css_show);   
  },
  addMenuListeners: function(){
    var _this = this;
    $(_this.menu_activator_selector).on('click',function(){
      _this.toggleMainMenu();
    });
    $(_this.search_activator_selector).on('click',function(){
      _this.toggleSearchTray();
    });    
    $(_this.cart_activator_selector).on('click',function(e){
      e.preventDefault();
      _this.toggleCartTray();
    });   
    $('.menu-item .has-children').on('click',function(){
      $(this).siblings('ul').toggleClass('active');
    });
    $(window).on('scroll',function(){
      $('.header-welcome').animate({"opacity":"0"},500);
    });
  }
}

/*============================================================================
  PRODUCT TABS CSV
==============================================================================*/

var productTabs = {
  tabsData: {},
  formattedTabsData: {},
  productSKU: "",
  currentTags: "",
  plus_svg: '<?xml version="1.0" encoding="utf-8"?><!-- Generator: Adobe Illustrator 23.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  --><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 786 768" style="enable-background:new 0 0 786 768;" xml:space="preserve"><style type="text/css">.stplus-d{fill:none;stroke:#000000;stroke-width:85.0394;stroke-linecap:round;stroke-miterlimit:10;}</style><line class="stplus-d" x1="69" y1="382.75" x2="719" y2="382.75"/><line class="stplus-d" x1="394" y1="57.75" x2="394" y2="707.75"/></svg>',
  init: function(){   
    var obj = this;        

    if($('#p-tag-item').length > 0){
      var tag_sheet_url = $('#p-tag-item').attr('data-url');
      obj.productSKU = $('#p-tag-item').attr('data-sku');
      obj.getData(tag_sheet_url);        
    }
          
  }, 
  setListeners: function(){
    $('.tab-header').on('click',function(){
      var tab_friend = $(this).siblings('.tab-body');
      
      if(tab_friend.hasClass('open')){
        tab_friend.removeClass('open');
        tab_friend.css({"overflow":"hidden"});
        tab_friend.animate({"height":"0px"},200);        
      }else{
        tab_friend.addClass('open');
        tab_friend.animate({"height":"150px"},200,function(){
          tab_friend.css({"overflow":"auto"});
        });      
      }        
    });  
  },
  generateTabs: function(sku){
    var obj = this;
    var prod = obj.findProduct(sku);
    var customer_tags = $('#p-tag-item').attr('data-tags').split(',');
    var tabs = [];
    if(customer_tags.length < 1){
      tabs = obj.formattedTabsData[sku].default;
    }else{
      for(var tag = 0; tag < customer_tags.length; tag++){
        if(typeof obj.formattedTabsData[sku] !== "undefined" && obj.formattedTabsData[sku].hasOwnProperty(customer_tags[tag])){
          tabs = obj.formattedTabsData[sku][customer_tags[tag]];
        }
      }
    }
    
    var tabs_html = "";
    
    for(var tab in tabs){
      var tab_content = tabs[tab].content;
      var tab_heading = tabs[tab].heading;
      
      tabs_html += "<div class='product-tab'>"+
                    "<div class='tab-header'><h4>"+tab_heading+"</h4>"+ obj.plus_svg+"</div>"+
                    "<div class='tab-body'>"+tab_content+"</div>"+
                   "</div>";
    }
    
    $('.product-tabs').html(tabs_html);
    
    obj.setListeners();
  },
  getData: function(url){
    var obj = this;
    $.ajax({
        type: "GET",
        url: url,
        dataType: "text",
        success: function(data) {
          var processed = obj.processData(data);
          obj.setTabsData(processed);
          obj.processTabsData();
          console.log('generating');
          obj.generateTabs(obj.productSKU);          
        }
    });  
  },
  processData: function(data){
    var dataDict = {}
    var csvObj = $.csv.toObjects(data);
    for (i = 0; i < csvObj.length; ++i) {
      var itemKey = csvObj[i].sku;
      if(!(itemKey in dataDict)){
        dataDict[itemKey] = {};
      }
      dataDict[itemKey] = csvObj[i];  
    }
    return dataDict;     
  },
  setTabsData: function(data){
    this.tabsData = data;
  },
  processTabsData: function(){
    var obj = this;
    for(var sku in obj.tabsData){
      var tabs = obj.tabsData[sku];
      if(typeof tabs != "undefined"){
        obj.formattedTabsData[sku] = {};
        for(var i = 1; i < 21; i++){
          if(tabs.hasOwnProperty("tag-"+i)){
            if(tabs["tag-"+i] !== ""){
              obj.formattedTabsData[sku][tabs["tag-"+i]] = [];              
              for(var j = 1; j < 21; j++){
                if(tabs.hasOwnProperty(i+"-"+j+"-content")){
                  if(tabs[i+"-"+j+"-content"] !== ""){
                    var tab = {};
                    tab.content = tabs[i+"-"+j+"-content"];
                    tab.heading = tabs[i+"-"+j+"-heading"];
                    obj.formattedTabsData[sku][tabs["tag-"+i]].push(tab);
                  }                  
                }else{
                  break;
                }
              }
            }            
          }else{
            break;
          }
        } 
      }      
    }
    console.log(obj.formattedTabsData);
  },
  findProduct: function(sku,tag){
    if(this.tabsData.hasOwnProperty(sku)){
      return this.tabsData[sku];
    }else{
      return undefined;
    }
  }
}

/*============================================================================
  ACCOUNT PAGE
==============================================================================*/

var accountPage = {
  items: [],
  init: function(){
    var _this = this;
    if(location.href.indexOf('/account') > -1){
      _this.setListeners();
    }
  },
  setListeners: function(){
    var _this = this;
    if(typeof reorder_info !== "undefined"){
      $('.reorder').on('click',function(){
        var order_i = parseInt($(this).attr('data-i'));
        _this.items = reorder_info[order_i];
        if(!$('.menu-toggle').hasClass('active')){
          $('#header-cart').click();
        }         
        _this.addToCart();
      });
    }else{
      console.log("Reording is currently disabled");
    }
  },
  addToCart: function(){
    console.log('reordering');
    var _this = this;
    if(_this.items.length > 0){
      var item = _this.items.pop();
      $.ajax({
        type: "POST",
        url: '/cart/add.js',
        data: item,
        success: function(data) {
          console.log("addded");
          _this.addToCart();
        }
      });
    }else{
      $('#refreshCart').click();
      location.reload();
    }
  }
}


/*============================================================================
  LOCAL WHOLESALE PRICING
==============================================================================*/
var wholesalePricing = {
  pricingData: {},
  rrpData: {},
  currentCart: {},
  allData: {},
  qtySet: false,
  currentQty: 0,
  defaultQtySet: false,
  flatDiscount: 0,
  customerTags: "",
  currentProductBracket: 1,
  previousProductBracket: 1,
  rrp_tag: "",
  wholesale_tag: "",
  init: function(){
    var obj = this;

      //use ajax to process .csv data                                   
      //Expected csv cols
      //1: sku 2: Title 3: increments 4: wholesale_price_1 5: from_quantity_1 6:to_quantity_1     

      obj.customer_tags = $('body').attr('data-customer-tags');

      var wholesale_sheet_url = "";
      var rrp_sheet_url = "";
    
      if(obj.customer_tags === "||" || obj.customer_tags === ""){
        obj.customer_tags = "|default|";
      }

      $('.wpl-item').each(function(){
        var tag = $(this).attr('data-tag');
        if(obj.customer_tags.indexOf(tag) > -1){
          obj.wholesale_tag = tag;
          wholesale_sheet_url = $(this).attr('data-url');                   
        }
      });
      $('.wpl-discount').each(function(){
        var tag = $(this).attr('data-tag');
        if(obj.customer_tags.indexOf(tag) > -1){
          wholesale_sheet_url = $(this).attr('data-url'); 
          obj.flatDiscount = parseFloat($(this).attr('data-discount'));
        }
      });      
      $('.rrp-item').each(function(){
        var tag = $(this).attr('data-tag');
        if(obj.customer_tags.indexOf(tag) > -1){
          obj.rrp_tag = tag;
          rrp_sheet_url = $(this).attr('data-url');                   
        }
      });
    
      if(wholesale_sheet_url === ""){
        $('.wpl-item').each(function(){
          if($(this).attr("data-tag").indexOf("|default|") > -1){
            obj.wholesale_tag = "|default|";
            wholesale_sheet_url = $(this).attr('data-url');                   
          }
        });
      }
    
      if(!$('body').hasClass('hide-money')){
        obj.getData(wholesale_sheet_url,rrp_sheet_url);
      }

      $('#create-script').on('click',function(){
        obj.dataToScript();
      }); 
    
      /*
      $('#checkout, form[action="/checkout"] button[type="submit"]').on('click',function(e){
        console.log('checkout check');
        e.preventDefault();
        obj.checkPricingAttached();
        location.href = "/checkout";
      });
      */

      obj.setListeners();
  },  
  getData: function(w_url,r_url){
    var obj = this;
    console.log('fetching data for'+w_url+" and "+r_url);
    if(w_url !== ""){
      $.ajax({
          type: "GET",
          url: w_url,
          dataType: "text",
          success: function(data) {
            if(r_url !== ""){
              $.ajax({
                  type: "GET",
                  url: r_url,
                  dataType: "text",
                  success: function(r_data) {
                    try{
                      var processed = obj.processData(r_data);
                      obj.setRRPData(processed);
                      processed = obj.processData(data);
                      obj.setPricingData(processed);
                      obj.setProductPagePricing();
                      obj.setCartPricing();
                      obj.setCartPagePricing();             
                      obj.setCollectionPagePricing();
                      obj.setQuickCollectionPricing();
                    }catch(e){
                      console.log("error processing "+r_url+" "+e);
                    }
                  }
              });        
            }else{
              try{
                var processed = obj.processData(data);
                obj.setPricingData(processed);
                obj.setProductPagePricing();
                obj.setCartPricing();
                obj.setCartPagePricing();             
                obj.setCollectionPagePricing();
                obj.setQuickCollectionPricing();
              }catch(e){
                console.log("error processing "+w_url+" "+e);
              }              
            }
            obj.disableManualQtyInput();
          }
      });
    }
  },
  setDefaultListeners: function(){
    var obj = this;
    
    //variant change
    $('.shopify-product-form select[name="id"]').on('change',function(){            
      console.log('change');
      var parent = $(this).closest('form');
      var id = $(this).val();
      parent.find('.purchase-details__quantity').attr('data-id', id);
    });
    
    //atc
    $('.atc-qty').off();
    $('.atc-qty').on('click',function(){      
      var parent = $(this).closest('.purchase-details__quantity');
      var id = parseInt(parent.attr('data-id'));
      var qty = parseInt(parent.find('input').val());      
      var product_data = {
        id: id,
        quantity: qty
      }      
      
      $.ajax({
        type: "POST",
        url: '/cart/add.js',
        data: product_data,
        success: function(data) {
          var p = JSON.parse(data);
          var current_count = parseInt($('.cart-count').text());
          var new_count = current_count + p.quantity;
          $('.cart-count').text(new_count).addClass('count-highlight');
          setTimeout(function(){
            $('.cart-count').removeClass('count-highlight');      
          },200);           
          $('#refreshCart').click();
        }
      });      
      
    });  
  },
  setListeners: function(){
    var obj = this;
    
    //variant change
    $('.shopify-product-form select[name="id"]').on('change',function(){            
      console.log('change');
      var parent = $(this).closest('form');
      var id = $(this).val();
      parent.find('.purchase-details__quantity').attr('data-id', id);
    });
    
    //atc
    $('.atc-qty').off();
    $('.atc-qty').on('click',function(){      
      var parent = $(this).closest('.purchase-details__quantity');
      var id = parseInt(parent.attr('data-id'));
      console.log('atc id '+id);
      var sku = parent.attr('data-sku');
      var qty = parseInt(parent.find('input').val());
      obj.addItem(id, sku, qty);
    });
    
    //quantity
    $('#quantity, .quantity').on('change',function(){      
      if($('.js-quick-shop').length > 0 && !$('body').hasClass('product')){
        obj.updateQuickshop($('.js-quick-shop').attr('data-sku'));
      }else{
        obj.setProductPagePricing();
      }    
    });        
  },
  addItem: function(id, sku, qty){
    var obj = this;
    
    var prod = obj.findProduct(sku);
    
    if(typeof prod !== "undefined"){

      //get number of pricing brackets      
      var product_data = {};    
      var price_ranges = 0;
      for(var key in prod){          
        if(prod.hasOwnProperty(key)){
          if(key.indexOf('wholesale_price') > -1 && prod[key] !== ""){
            price_ranges++;
          }
        }
      } 
      
      // set default bracket values
      var cents_mod = 100 - obj.flatDiscount;        

      //set price
      var price = obj.testPriceBracket(qty,prod,price_ranges);
      var price_f = parseInt(parseFloat(price.replace('$','')) * cents_mod);
      var formatted_price = Shopify.formatMoney(price_f, $('body').data('money-format'));   
      
      product_data = {
        id: id,
        quantity: qty,
        properties: {
          "wholesale_price": formatted_price
        }
      }
      
      console.log('adding');
      
      $.ajax({
        type: "POST",
        url: '/cart/add.js',
        data: product_data,
        success: function(data) {
          var p = JSON.parse(data);
          var current_count = parseInt($('.cart-count').text());
          var new_count = current_count + p.quantity;
          $('.cart-count').text(new_count).addClass('count-highlight');
          setTimeout(function(){
            $('.cart-count').removeClass('count-highlight');      
          },200);           
          $('#refreshCart').click();
        }
      });
    }else{
      //alert to non product
    }    
  },
  disableManualQtyInput: function(){
    $('input[name="quantity"], input.quantity').attr('disabled','disabled');
  },
  setRRPData: function(data){
    this.rrpData = data;
  },
  processData: function(data){
    var dataDict = {}
    var csvObj = $.csv.toObjects(data);
    for (i = 0; i < csvObj.length; ++i) {
      var itemKey = csvObj[i].sku;
      if(!(itemKey in dataDict)){
        dataDict[itemKey] = {};
      }
      dataDict[itemKey] = csvObj[i];  
    }
    return dataDict;     
  },
  setProductPagePricing: function(){
    var obj = this;
    if($('.shopify-product-form').find('select option:selected').length > 0){
      var sku = $('.shopify-product-form').find('select[name="id"] option:selected').attr('data-sku');    
      var prod = this.findProduct(sku);
      if(typeof prod !== 'undefined'){        
        
        // establish number of wholesale brackets
        var price_ranges = 0;
        for(var key in prod){          
          if(prod.hasOwnProperty(key)){
            if(key.indexOf('wholesale_price') > -1 && prod[key] !== ""){
              price_ranges++;
            }
          }
        }        
        
        // set default bracket values
        var cents_mod = 100 - obj.flatDiscount;       
                
        // set quantity box tracking
        var qty_input = $('.purchase-details__quantity input.quantity');
        if(obj.defaultQtySet === false){
          qty_input.attr('data-increments', prod.increments);
          qty_input.val(prod.increments);
          obj.defaultQtySet = true;
        }
        
        // write pricing grid        
        var pricing_grid = "<div><div>Qty</div><div>Price</div></div>";
        pricing_grid += "</div></div>";
        
        if(price_ranges > 1){
          for(var i=1;i<(price_ranges+1);i++){
            var wpk = "wholesale_price_"+i;
            var wqt = "to_quantity_"+i;
            var wqf = "from_quantity_"+i;
            var sp2 = prod[wpk].replace('$','');
            var wpic = parseInt(parseFloat(sp2) * cents_mod);
            var wfp = Shopify.formatMoney(wpic, $('body').data('money-format'));

            if(i === 1){
              pricing_grid += "<div><div>1-"+prod[wqt]+"</div><div>"+wfp+"</div></div>";
            }else{
              pricing_grid += "<div><div>"+prod[wqf]+" and above</div><div>"+wfp
            }
          }
          $('.price-grid-display').show();
          $('.price-grid-display').html(pricing_grid); 
        }else{
          $('.price-grid-display').hide();
        }
        
        //set price on page
        var qty = parseInt($('#quantity').val());
        var price = obj.testPriceBracket(qty,prod,price_ranges);
        var price_f = parseInt(parseFloat(price.replace('$','')) * cents_mod);
        var formatted_price = Shopify.formatMoney(price_f, $('body').data('money-format'));
        
        $('.product_section .current_price').text(formatted_price);
        $('#product-wholesale-price').val(formatted_price);
        $('.shopify-product-form .add_to_cart').attr('disabled',false).removeClass('disabled'); 
        
        
        // set bracket so we can display the page prompt to the user when necessary
        if(obj.currentProductBracket !== obj.previousProductBracket){
          obj.previousProductBracket = obj.currentProductBracket;
          obj.highlightProductPrice();
        } 
        
        // set RRP if available
        var rrp_prod = obj.findRRP(sku);
        if(typeof rrp_prod !== 'undefined'){
          var rrp_f = parseInt(parseFloat(rrp_prod.price).toFixed(2) * 100);
          var rrp_saving = rrp_f - price_f;
          var rrp_wording = "Save: ";
          if(obj.rrp_tag === "|rrp_distributor|"){
            rrp_wording = "Margin: ";
          }
          if($('.product_page_rrp').length > 0){
            $('.product_page_rrp_saving').html(rrp_wording+' '+Shopify.formatMoney(rrp_saving, $('body').data('money-format')));
            $('.product_page_rrp').html('RRP: <span>'+Shopify.formatMoney(rrp_f, $('body').data('money-format'))+'</span>');            
          }else{
            $('.modal_price').append('<span class="product_page_rrp">RRP: <span>'+Shopify.formatMoney(rrp_f, $('body').data('money-format'))+'</span></span>');
            $('.modal_price').append('<span class="product_page_rrp_saving">'+rrp_wording+' '+Shopify.formatMoney(rrp_saving, $('body').data('money-format'))+'</span>');            
          }
        }

        //trigger quantity change
        if(obj.qtySet === false){
          obj.qtySet = true;
          $('#quantity').trigger('change');          
        }
      }else{
        $('.product_section .current_price').text("No price available - purchase disabled");
        $('.shopify-product-form .add_to_cart').attr('disabled','disabled').addClass('disabled');
      }
    }  
  },
  testPriceBracket: function(qty,prod,bracketCount){
    var obj = this;
    var price = prod.wholesale_price_1;    
    for(var i=1; i<(bracketCount+1); i++){
      var tq = "from_quantity_"+i;
      var pb = "wholesale_price_"+i;
      if(qty > (parseInt(prod[tq])-1)){
        obj.currentProductBracket = i;
        price = prod[pb];
      }
    }
    return price;
  },
  highlightProductPrice: function(){
    $('.product_section .current_price').addClass('highlight');
    setTimeout(function(){
      $('.product_section .current_price').removeClass('highlight');      
    },1000);    
  },
  getAllData: function(lists){
    var obj = this;
    if(lists.length > 0){
      var list = lists.pop();
      var url = list.url;
      var tag = list.tag      
      $.ajax({
          type: "GET",
          url: url,
          dataType: "text",
          success: function(data) {
            var processed = obj.processData(data);
            obj.allData[tag] = processed;
            obj.getAllData(lists);
          }
      });   
    }else{
      obj.processAllData();
    }
  },
  dataToScript: function(){
    var prices = {};
    var pricesToGet = $('.wpl-item').length;
    var processFailed = false;
    var lists = [];
    
    $('.wpl-item').each(function(){
      lists.push({ "tag": $(this).attr('data-tag'),
                  "url": $(this).attr('data-url')
               });      
    });    
    
    this.getAllData(lists);    
  },
  setCartPricing: function(){
    var obj = this;
    var total_price = 0;
    var cents_mod = 100 - obj.flatDiscount;
    $('.cart-slide-wrapper .js-cart_content__form .cart-item').each(function(){
      var sku = $(this).attr('data-sku');
      var prod = obj.findProduct(sku);
      if(typeof prod !== 'undefined'){    
        //set quantity box increments
        $(this).find('.product-quantity-box input').attr('data-increments',prod.increments);
                
        // establish number of wholesale brackets
        var price_ranges = 0;
        for(var key in prod){          
          if(prod.hasOwnProperty(key)){
            if(key.indexOf('wholesale_price') > -1 && prod[key] !== ""){
              price_ranges++;
            }
          }
        }        
        
        // set default bracket values
        var cents_mod = 100 - obj.flatDiscount;       
        
        //set price on page
        var qty = parseInt($(this).find('.product-quantity-box input').val());
        var price = obj.testPriceBracket(qty,prod,price_ranges);
        var price_f = parseInt(parseFloat(price.replace('$','')) * cents_mod);
        var line_f = price_f * qty;
        var formatted_price = Shopify.formatMoney(price_f, $('body').data('money-format'));
        var line_formatted = Shopify.formatMoney(line_f, $('body').data('money-format'));
        
        total_price += price_f;
        
        $(this).find('.cart_item__ind-price').text(formatted_price);
        $(this).find('.cart_item__line-price').text(line_formatted);
        
        // set RRP if available
        var rrp_prod = obj.findRRP(sku);
        if(typeof rrp_prod !== 'undefined'){
          var rrp_f = parseInt(parseFloat(rrp_prod.price).toFixed(2) * 100);
          
          $('.cart_item__rrp').html('RRP: <span>'+Shopify.formatMoney(rrp_f, $('body').data('money-format'))+'</span>');            

        }                              
      }
    });
    var total_price_formatted = Shopify.formatMoney(total_price, $('body').data('money-format'));
    $('.js-cart_subtotal .money').text(total_price_formatted);
    obj.setListeners();
    obj.checkPricingAttached();
    obj.disableManualQtyInput();
  },
  setCollectionPagePricing: function(){
    
    console.log('setting collection');
    
    var obj = this;
    var cents_mod = 100 - obj.flatDiscount;
    var rrp_wording = "Save";
    if(obj.rrp_tag === "|rrp_distributor|"){
      rrp_wording = "Margin";
    } 
    $('.price small').remove();
    $('.product-list .product-details').each(function(){
      var sku = $(this).attr('data-sku');
      var price_wrapper = $(this).find('.product-pricing-info');
      var sale_price = price_wrapper.find('.sale-price');
      var additional_pricing = price_wrapper.find('.product-additional-pricing');
      var prod = obj.findProduct(sku); 
      var rrp_prod = obj.findRRP(sku);
      if(typeof prod !== 'undefined'){
        
        // establish number of wholesale brackets
        var price_ranges = 0;
        for(var key in prod){          
          if(prod.hasOwnProperty(key)){
            if(key.indexOf('wholesale_price') > -1 && prod[key] !== ""){
              price_ranges++;
            }
          }
        } 
        
        $(this).find('.quantity').attr('data-increments', prod.increments).val(prod.increments);

        
        // set default bracket values
        var cents_mod = 100 - obj.flatDiscount;       
        
        //set price on page
        var price = obj.testPriceBracket(1,prod,price_ranges);
        var price_f = parseInt(parseFloat(price.replace('$','')) * cents_mod);
        var formatted_price = Shopify.formatMoney(price_f, $('body').data('money-format'));
        
        sale_price.text(formatted_price);
        
        // set RRP if available
        if(typeof rrp_prod !== 'undefined'){
          var rrp_f = parseInt(parseFloat(rrp_prod.price).toFixed(2) * 100);
          var rrp_saving = rrp_f - price_f;
          var rrp_wording = "Save";
          if(obj.rrp_tag === "|rrp_distributor|"){
            rrp_wording = "Margin";
          }
          
          var rrp_html = "<span class='rrp'>RRP: "+Shopify.formatMoney(rrp_f, $('body').data('money-format'))+"</span>"+
                         "<span class='rrp_saving'>"+rrp_wording+" "+Shopify.formatMoney(rrp_saving, $('body').data('money-format'))+"</span>";
          
          additional_pricing.html(rrp_html);            
        }
      }       
    });
    $('.collection .price, .product-additional-pricing').css({"opacity":"1"});
  },
  setQuickCollectionPricing: function(){
    var obj = this;
    $('.quick-collection-table tr').each(function(){
      var sku = $(this).find('.qo-sku').text().trim();
      var prod = obj.findProduct(sku);
      if(typeof prod !== "undefined"){
        
        //find wholesale brackets
        var price_ranges = 0;
        for(var key in prod){          
          if(prod.hasOwnProperty(key)){
            if(key.indexOf('wholesale_price') > -1 && prod[key] !== ""){
              price_ranges++;
            }
          }
        }         
        
        //set price display
        var price_display = "<div>";
        var price = "";
        var price_in_cents = 0;
        
        if(price_ranges > 1){
          for(var i = 0; i < price_ranges; i++){
            price = "";
            if(i === 0){
              price_display += "<span>Less than "+(parseInt(prod.to_quantity_1)+1)+"</span>";
            }else{
              price_display += "<span>"+prod["from_quantity_"+(i+1)]+" or more</span>";
            } 
            price_in_cents = parseInt(parseFloat(prod["wholesale_price_"+(i+1)].replace('$',''))*100);
            price = Shopify.formatMoney(price_in_cents, $('body').data('money-format'));
            price_display += "<span class='qo-price-range'>"+price+"</span>";
          }
        }else{
          price_in_cents = parseInt(parseFloat(prod.wholesale_price_1.replace('$',''))*100);
          price = Shopify.formatMoney(price_in_cents, $('body').data('money-format'));
          price_display += "<span class='qo-price-range'>"+price+"</span>";
        }
            
        price_display += "</div>";
        
        // set quantity box tracking
        var qty_input = $(this).find('.quantity');
        
        qty_input.attr('data-increments', prod.increments);            
        
        $(this).find('.qo-price').html(price_display);
                
      }
      $('.add-to-cart-order-form').attr('disabled',false);
    });
  },
  setCartPagePricing: function(){
    var obj = this;
    var total_price = 0;
    var cents_mod = 100 - obj.flatDiscount;
    $('.cart-line-item').each(function(){
      var sku = $(this).attr('data-sku');
      var prod = obj.findProduct(sku); 
      if(typeof prod !== 'undefined'){ 
        $(this).find('.product-quantity-box input').attr('data-increments',prod.increments);
        var qty = parseInt($(this).find('.product-quantity-box input').val());
        var stringPrice = prod.wholesale_price_1.replace('$','');
        var price_in_cents = parseInt(parseFloat(stringPrice) * cents_mod) * qty;
        var formatted_price = Shopify.formatMoney(price_in_cents, $('body').data('money-format'));
        var second_tier = {};        
        if(prod.hasOwnProperty('wholesale_price_2') && prod.wholesale_price_2 !== ""){
          second_tier["starting_qty"] = prod.from_quantity_2
          var sp2 = prod.wholesale_price_2.replace('$','');
          var pic2 = parseInt(parseFloat(sp2) * cents_mod) * qty;
          second_tier["price"] = Shopify.formatMoney(pic2, $('body').data('money-format'));
        } 
        if(second_tier === {}){
          $(this).find('.modal_price span').first().text(formatted_price);
          total_price += price_in_cents;
        }else{          
          if(qty > parseInt(prod.to_quantity_1)){
            $(this).find('.modal_price span').first().text(second_tier.price); 
            total_price += pic2;
          }else{
            $(this).find('.modal_price span').first().text(formatted_price);
            total_price += price_in_cents;
          }
        }                
      }
    });
    var total_price_formatted = Shopify.formatMoney(total_price, $('body').data('money-format'));
    $('.cart .cart_subtotal.js-cart_subtotal .money').text(total_price_formatted);  
    obj.setListeners();
    obj.checkPricingAttached();
  },
  checkPricingAttached: function(){
    console.log('checking pricing');
    var obj = this;
    var line = 1;
    $.ajax({
        type: "GET",
        url: '/cart.js',
        dataType: "text",
        success: function(data) {
          var cart = JSON.parse(data) || data;        
          
          for(var i = 0; i < cart.items.length; i++){
            var item = cart.items[i];
            if(item.sku !== null){
              var prod = obj.findProduct(item.sku);
              if(typeof prod !== 'undefined'){  

                // establish number of wholesale brackets
                var price_ranges = 0;
                for(var key in prod){          
                  if(prod.hasOwnProperty(key)){
                    if(key.indexOf('wholesale_price') > -1 && prod[key] !== ""){
                      price_ranges++;
                    }
                  }
                }        

                // set flat discount modifier
                var cents_mod = 100 - obj.flatDiscount;       

                //set price
                var price = obj.testPriceBracket(item.quantity,prod,price_ranges);
                var price_f = parseInt(parseFloat(price.replace('$','')) * cents_mod);
                var formatted_price = Shopify.formatMoney(price_f, $('body').data('money-format'));
                $.post('/cart/change.js', { quantity: item.quantity, line: line, properties: {"wholesale_price":formatted_price} });
                
              }
            }
            line++;
          }
        }
    });    
  },
  setPricingData: function(data){
    this.pricingData = data;
  },
  findProduct: function(sku,tag){
    if(this.pricingData.hasOwnProperty(sku)){
      return this.pricingData[sku];
    }else{
      return undefined;
    }
  },
  findRelevantPrice: function(){
  
  },
  findRRP: function(sku,tag){
    if(this.rrpData.hasOwnProperty(sku)){
      return this.rrpData[sku];
    }else{
      return undefined;
    }
  },  
  getPricingData: function(){
    return this.pricingData;
  },
  updateQuickshop: function(sku){  
    
    /* No Longer Used */
    
    var obj = this;
    var prod = obj.findProduct(sku);
    var cents_mod = 100 - obj.flatDiscount;
    if(typeof prod !== 'undefined'){
      
      // establish number of wholesale brackets
      var price_ranges = 0;
      for(var key in prod){          
        if(prod.hasOwnProperty(key)){
          if(key.indexOf('wholesale_price') > -1 && prod[key] !== ""){
            price_ranges++;
          }
        }
      }        
      
      // set default bracket values
      var cents_mod = 100 - obj.flatDiscount;  
      
      // set quantity box tracking
      var qty_input = $('.js-product-form #quantity');
      qty_input.attr('data-increments', prod.increments);
      //qty_input.val(prod.increments); 
      qty_input.attr('disabled',false);
      
      // write pricing grid        
      var pricing_grid = "<div><div>Qty</div><div>Price</div></div>";
      pricing_grid += "</div></div>";

      if(price_ranges > 1){
        for(var i=1;i<(price_ranges+1);i++){
          var wpk = "wholesale_price_"+i;
          var wqt = "to_quantity_"+i;
          var wqf = "from_quantity_"+i;
          var sp2 = prod[wpk].replace('$','');
          var wpic = parseInt(parseFloat(sp2) * cents_mod);
          var wfp = Shopify.formatMoney(wpic, $('body').data('money-format'));

          if(i === 1){
            pricing_grid += "<div><div>1-"+prod[wqt]+"</div><div>"+wfp+"</div></div>";
          }else{
            pricing_grid += "<div><div>"+prod[wqf]+" and above</div><div>"+wfp
          }
        }
        $('.price-grid-display').show();
        $('.price-grid-display').html(pricing_grid); 
      }else{
        $('.price-grid-display').hide();
      }
      
      //set price on page
      var qty = parseInt(qty_input.val());
      var price = obj.testPriceBracket(qty,prod,price_ranges);
      var price_f = parseInt(parseFloat(price.replace('$','')) * cents_mod);
      var formatted_price = Shopify.formatMoney(price_f, $('body').data('money-format'));
      
      $('.modal_price .current_price').text(formatted_price);
      $('.js-product-form #product-wholesale-price').val(formatted_price);
      $('.shopify-product-form .add_to_cart').attr('disabled',false).removeClass('disabled');  
      
      // set RRP if available
      var rrp_prod = obj.findRRP(sku);
      if(typeof rrp_prod !== 'undefined'){
        var rrp_f = parseInt(parseFloat(rrp_prod.price).toFixed(2) * 100);
        var rrp_saving = rrp_f - price_f;
        var rrp_wording = "Save";
        if(obj.rrp_tag === "|rrp_distributor|"){
          rrp_wording = "Margin";
        }
        if($('.quick-shop__text-wrap .product_page_rrp_saving').length > 0){
          //$('.quick-shop__text-wrap .product_page_rrp_saving').html(rrp_wording+' '+Shopify.formatMoney(rrp_saving, $('body').data('money-format')));
          $('.quick-shop__text-wrap .product_page_rrp').html('RRP: <span>'+Shopify.formatMoney(rrp_f, $('body').data('money-format'))+'</span>');            
        }else{
          $('.quick-shop__text-wrap .modal_price').append('<span class="product_page_rrp">RRP: <span>'+Shopify.formatMoney(rrp_f, $('body').data('money-format'))+'</span></span>');
          //$('.quick-shop__text-wrap .modal_price').append('<span class="product_page_rrp_saving">'+rrp_wording+' '+Shopify.formatMoney(rrp_saving, $('body').data('money-format'))+'</span>');            
        }
      }      
      
    }else{
      $('.js-product_section .current_price').text("No price available - purchase disabled");
      $('.js-product-form .add_to_cart').attr('disabled','disabled').addClass('disabled');
    }    
    
  }
}
    